import React from 'react';
import { Phone, Mail, Facebook, Instagram, MapPin, Clock } from 'lucide-react';
import SectionTitle from '../components/ui/SectionTitle';
import ContactForm from '../components/ui/ContactForm';

const Contact: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gray-light">
        <div className="container-custom">
          <h1 className="font-bold mb-4">Kontakt</h1>
          <p className="text-xl text-gray-600">
            Ich freue mich auf Ihre Nachricht. Sprechen wir über Ihre individuelle Absicherung.
          </p>
        </div>
      </section>
      
      {/* Contact Information */}
      <section className="section">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <SectionTitle title="Schreiben Sie mir" />
              <ContactForm />
            </div>
            
            {/* Contact Info & Map */}
            <div>
              <SectionTitle title="Kontaktinformationen" />
              
              <div className="bg-gray-light p-8 rounded-lg mb-8">
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <Phone className="text-primary flex-shrink-0 mt-1" size={24} />
                    <div>
                      <h4 className="font-semibold mb-1">Telefon</h4>
                      <a href="tel:+4989201759656" className="text-gray-600 hover:text-primary transition-colors block">
                        Festnetz: +49 89 90157634
                      </a>
                      <a href="tel:+491711144557" className="text-gray-600 hover:text-primary transition-colors block">
                        Mobil: +49 171 1144557
                      </a>
                      <span className="text-gray-500 text-sm">(auch WhatsApp)</span>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Mail className="text-primary flex-shrink-0 mt-1" size={24} />
                    <div>
                      <h4 className="font-semibold mb-1">E-Mail</h4>
                      <a href="mailto:m.meier@vorsorgewerk24.de" className="text-gray-600 hover:text-primary transition-colors">
                        m.meier@vorsorgewerk24.de
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <MapPin className="text-primary flex-shrink-0 mt-1" size={24} />
                    <div>
                      <h4 className="font-semibold mb-1">Standort</h4>
                      <p className="text-gray-600">
                        Starnberger Str. 24<br />
                        82131 Gauting<br />
                        München und Umgebung<br />
                        Beratung deutschlandweit verfügbar
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <Clock className="text-primary flex-shrink-0 mt-1" size={24} />
                    <div>
                      <h4 className="font-semibold mb-1">Erreichbarkeit</h4>
                      <div className="text-gray-600 space-y-2">
                        <div>
                          <p className="font-medium">Automatisierter Support</p>
                          <p>Montag – Freitag: 9:00 – 20:00 Uhr</p>
                        </div>
                        <div>
                          <p className="font-medium">Persönliche Beratung mit Monica</p>
                          <p>Montag – Freitag: 17:00 – 20:00 Uhr</p>
                          <p>Samstag: 9:00 - 15:00 Uhr</p>
                        </div>
                        <p className="italic">Oder nach Vereinbarung</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Map */}
              <div className="relative w-full h-[400px] rounded-lg overflow-hidden shadow-lg">
                <iframe 
                  src="https://www.openstreetmap.org/export/embed.html?bbox=11.365318298339846%2C48.06663431108352%2C11.385531425476076%2C48.07663431108352&layer=mapnik&marker=48.07163431108352%2C11.375424861907959"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute top-0 left-0 w-full h-full"
                  title="Standort Monica Meier Versicherungsberatung"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Direct Contact CTA */}
      <section className="section bg-primary text-white">
        <div className="container-custom text-center">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6">
            Lieber direkt sprechen?
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            Für eine persönliche Beratung rufen Sie mich gerne an oder senden Sie eine WhatsApp-Nachricht.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a 
              href="tel:+4989201759656" 
              className="btn bg-white text-primary hover:bg-gray-100"
            >
              <Phone size={20} className="mr-2" /> Festnetz anrufen
            </a>
            <a 
              href="tel:+491711144557" 
              className="btn bg-white text-primary hover:bg-gray-100"
            >
              <Phone size={20} className="mr-2" /> Mobil anrufen
            </a>
            <a 
              href="https://wa.me/+491711144557" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn bg-[#25D366] text-white hover:bg-[#128C7E]"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;